<template>
  <p>
    La facilidad de Dinámica de Fluidos Geofísicos Computacional tiene como
    objetivo fundamental estudiar el comportamiento complejo de los fluídos
    (e.g., el océano, la atmósfera) desarrollados a diferentes escalas de
    movimiento, en diferentes sistemas y bajo diferentes formas, los cuales se
    rigen por una dinámica similar (i.e. los principios fundamentales de la
    dinámica de fluidos y la termodinámica). El enfoque metodológico que se
    emplea se basa en la modelación numérica que incluye el uso, la
    implementación, la calibración, la optimización y el desarrollo de modelos
    numérico para resolver problemas que involucren la dinámica de la Tierra, su
    interacción con los seres vivos, los procesos naturales que pueden afectar
    al ser humano y el efecto de éste sobre los procesos físicos naturales en
    diferentes escalas de espacio y tiempo (e.g., sobre todo el planeta o una
    región en particular y además, en el pasado, presente o futuro).
  </p>
  <p>
    La facilidad cuenta con el Sistema Computacional de Alto Rendimiento de
    última generación (HPC-Linux-Clúster) dedicado a suplir la “necesidad
    computacional” (capacidad de cálculo o procesamiento) de las actuales
    investigaciones científicas de alto nivel que se desarrollan en el Instituto
    Geofísico del Perú, las cuales están dedicadas a resolver y analizar los
    fenómenos geofísicos (naturales y/o de origen antropogénico) que afectan a
    la población peruana y sus actividades. Asimismo, provee a las
    universidades, instituciones y centros de investigación que lo requieran
    (siguiendo el protocolo establecido) la capacidad de cómputo necesaria a fin
    de fortalecer las investigaciones científicas y el desarrollo tecnológico en
    beneficio del Perú.
  </p>
  <Figure>
    <Image
      :srcsets="['/images/imaganes_in_volcanes_0.jpg']"
      title="Acerca de la facilidad"
    />
  </Figure>
</template>
<script>
import Figure from "@/components/ui/objects/Figure.vue";
import Image from "@/components/ui/objects/Image.vue";
export default {
  components: {
    Figure,
    Image
  },
  setup() {}
};
</script>
